import React from 'react';
import { HashRouter, Navigate, NavLink, Route, Routes } from 'react-router-dom';
import Fleet from './pages/Fleet';
import Training from './pages/Training';

const navStyle = ({ isActive }: { isActive: boolean }) => ({
    display: 'block',
    padding: '12px 14px',
    borderRadius: '6px',
    color: isActive ? '#fff' : '#cbd5e1',
    backgroundColor: isActive ? '#2563eb' : 'transparent',
    textDecoration: 'none',
    fontWeight: isActive ? 600 : 400,
});

const App: React.FC = () => (
    <HashRouter>
        <div style={{ display: 'flex', height: '100vh', fontFamily: 'sans-serif', backgroundColor: '#f8fafc' }}>
            <aside style={{ width: '200px', padding: '24px 16px', boxSizing: 'border-box', backgroundColor: '#0f172a' }}>
                <h2 style={{ margin: '0 0 24px', color: '#fff' }}>Bepro AI</h2>
                <nav style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <NavLink to="/training" style={navStyle}>Training</NavLink>
                    <NavLink to="/fleet" style={navStyle}>Fleet</NavLink>
                </nav>
            </aside>

            <main style={{ flex: 1, padding: '24px', boxSizing: 'border-box', overflow: 'hidden' }}>
                <Routes>
                    <Route path="/training" element={<Training />} />
                    <Route path="/fleet" element={<Fleet />} />
                    <Route path="*" element={<Navigate to="/training" replace />} />
                </Routes>
            </main>
        </div>
    </HashRouter>
);

export default App;